import { Box, Checkbox, Typography, styled } from '@mui/material'

export const StyledCheckbox = styled(Checkbox)(() => ({
  padding: 2,
  '&:hover': {
    backgroundColor: 'transparent'
  }
}))

export const IconCheckbox = styled('span')(({ theme }) => ({
  borderRadius: 30,
  width: 12,
  height: 12,
  border: `2px solid ${theme.palette.grey[400]}`,
  backgroundColor: '#f5f8fa',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '$root.Mui-focusVisible &': {
    outline: `2px auto ${theme.palette.success.main}`,
    outlineOffset: 2
  },
  '&:hover': {
    backgroundColor: theme.palette.common.white
  },
  '&.checked': {
    border: `2px solid ${theme.palette.success.main}`,
    backgroundColor: theme.palette.common.white,
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 12,
      height: 12,
      filter: 'invert(22%) sepia(79%) saturate(414%) hue-rotate(34deg) brightness(92%) contrast(87%)',
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""'
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.common.white
    }
  }
}))

type OptionFilterUserProps = {
  text: string
  checked?: boolean
  onChange?: any
}

function CustomCheckbox({ text, checked = false, onChange }: OptionFilterUserProps) {
  return (
    <Box display="flex" gap="4px" padding="2px 0px" alignItems="center" boxSizing="content-box">
      <StyledCheckbox
        disableRipple
        checkedIcon={<IconCheckbox className="checked" />}
        icon={<IconCheckbox />}
        inputProps={{ 'aria-label': 'decorative checkbox' }}
        checked={checked}
        onChange={onChange}
      />
      <Typography color="textSecondary" variant="body2" style={{ height: 18, whiteSpace: 'nowrap' }}>
        {text}
      </Typography>
    </Box>
  )
}

export default CustomCheckbox
